import { ASSESSMENT_CONFIG } from '@/utils/const/products/vod-assessment';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import {
  formatPercentNumber,
  getBitRates,
  storageUsageRate,
  transcodeCompressRate,
} from '../../../utils/functions/vod-assessment';
import FadeIn from '../../commonComponents/fadeIn';
import IndicatorCard from './AssessmentTemplates/IndicatorCard';
import SceneSelect from './AssessmentTemplates/SceneSelect';
import BusinessDataConfig from './BusinessDataConfig';
import Styles from './index.module.scss';
interface IProps {
  videoConfigs: any;
}

interface IIndicatorData {
  transcode: number | string;
  storage: number | string;
  cdn: number | string;
}

const Assessment = ({ videoConfigs }) => {
  const [currentScene, setCurrentScene] = useState({
    scene: 'UGC',
    quality: ['H265', 'H264'],
  });
  const sceneSelectChange = (val) => {
    setCurrentScene(val);
  };

  useEffect(() => {
    assessment(
      currentScene.scene,
      currentScene.quality[0],
      currentScene.quality[1]
    );
  }, [currentScene]);

  // 各项指标
  const [indicatorData, setIndicatorData] = useState({} as IIndicatorData);
  function assessment(scene, targetQuality, originQuality) {
    // 获取码率
    const { bitRate, targetBitRates, originBitRates } = getBitRates(
      scene,
      targetQuality,
      originQuality,
      videoConfigs
    );
    // 转码压缩率
    const transcodeRes = transcodeCompressRate(
      bitRate,
      targetBitRates,
      originBitRates
    );
    // 媒资存储
    const storageUsageRes = storageUsageRate(
      bitRate,
      targetBitRates,
      originBitRates
    );
    setIndicatorData({
      transcode: formatPercentNumber(transcodeRes),
      storage: formatPercentNumber(storageUsageRes),
      cdn: formatPercentNumber(transcodeRes),
    });
  }

  return (
    <div className={Styles.assessmentContainer}>
      <div className={Styles.title}>{ASSESSMENT_CONFIG.title}</div>
      <div className={Styles.desc}>{ASSESSMENT_CONFIG.desc}</div>
      <Row justify="space-between" style={{ marginTop: 40 }}>
        <Col>
          <SceneSelect value={currentScene} onChange={sceneSelectChange} />
        </Col>
        <Col>
          <Row justify="space-between" style={{ width: 505 }}>
            <IndicatorCard
              value={indicatorData.transcode}
              unit="%"
              desc={ASSESSMENT_CONFIG.indicators.transcode}
              type={(indicatorData.transcode as number) > 0 ? 'down' : 'up'}
            />
            <IndicatorCard
              value={indicatorData.storage}
              unit="%"
              desc={ASSESSMENT_CONFIG.indicators.storage}
              type={(indicatorData.storage as number) > 0 ? 'up' : 'down'}
            />
            <IndicatorCard
              value={indicatorData.cdn}
              unit="%"
              desc={ASSESSMENT_CONFIG.indicators.cdn}
              type={(indicatorData.cdn as number) > 0 ? 'up' : 'down'}
            />
          </Row>
        </Col>
      </Row>
      <FadeIn>
        <BusinessDataConfig
          targetQuality={currentScene.quality[0]}
          originQuality={currentScene.quality[1]}
          scene={currentScene.scene}
          videoConfigs={videoConfigs}
        />
      </FadeIn>
    </div>
  );
};

export default Assessment;
